export default __webpack_public_path__ + "static/media/noun_transaction_2182047.5a8cef42.svg";